import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import "./css/Navbar.css"
import { toast } from "react-toastify";
import { setUserAvatar, setUserEmail, setUserId, setUserName, setUserPhone, setUserAddress, setUserCity, setUserState } from "../../src/Redux/reducers/UserSlice";
import axios from "axios";


const Navbar = ({ isAuthenticatedAd, setAuth, setActive, setActiveManagement }) => {
    const totalCarts = useSelector((state) => {
        if (state.cart.totalCarts < 10) {
            return ('0' + state.cart.totalCarts)
        } else return state.cart.totalCarts
    });





    // const userId = useSelector(state => state.user.userId)
    // const userName = useSelector(state => state.user.userName)
    const dispatch = useDispatch();
    const { apiUrl } = useSelector(state => state.api);

    const { userId, userName, userAvatar } = useSelector(state => state.user)
    // console.log(userId, userName, userEmail, userAvatar);
    let token = localStorage.getItem('token');

    useEffect(() => {
        if (token) {
            const findInfo = async () => {
                try {
                    const response = await axios.get(`${apiUrl}/myaccount`, {
                        headers: { token: localStorage.token }
                    })
                    if (response.status === 200) {
                        const parseRes = response.data;
                        // console.log(parseRes.user_avatar);
                        dispatch(setUserAvatar(parseRes.user_avatar));
                        dispatch(setUserName(parseRes.user_name));
                        dispatch(setUserId(parseRes.user_id));
                    } else if (response.status === 401) {

                        return response.text().then(message => {
                            console.log(message);
                        })
                    }
                } catch (err) {
                    console.error(err.message);
                    // console.error("You are not logged in.");
                }
            }
            findInfo();
        }
    }, [token, dispatch]);

    const logout = (e) => {
        e.preventDefault()
        localStorage.removeItem("token");
        localStorage.removeItem("cart");
        localStorage.removeItem("reduxState");
        setAuth(false)
        // setAuthAd(false)
        toast.success("Logged out successfully!")
        setTimeout(() => {
            window.location.href = '/';
        }, 1000);
    }
    // console.log(isAuthenticatedAd);
    return (
        <>
            {/* navbar */}
            <nav class="navbar navbar-expand-lg navbar-light bg-light shadow-sm">
                <div class="container-fluid">
                    {/* <!-- Shop logo and name --> */}

                    <Link to="/"  >
                        <div class="navbar-brand">
                            <img src="frusti.jpg" alt="Frusit" style={{ height: "50px", width: "50px" }} />
                        </div>
                    </Link>

                    {/* <!-- Toggle button for smaller screens --> */}
                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>

                    <div class="collapse navbar-collapse" id="navbarNav">

                        {(isAuthenticatedAd && isAuthenticatedAd !== "user") && <ul class="navbar-nav me-auto ">
                            {/* <!-- Dashboard --> */}
                            <li class="nav-item">
                                <Link to="/dashboard/" class="nav-link"
                                    onClick={() => setActiveManagement("Products")}
                                >Dashboard</Link>
                            </li>
                        </ul>}

                        <ul class="navbar-nav ms-auto">
                            {/* <!-- My Account --> */}
                            {!userId ? (<li class="nav-item">
                                <Link to="/login" class="nav-link">My Account</Link>
                            </li>
                            ) : (
                                <div class="dropdown">

                                    <div class="nav-link" id="dropdownMenuButton" aria-expanded="false">
                                        <img src={apiUrl + "/" + userAvatar} alt="Avatar" class="navbar-brand " width="35" height="35" />
                                        {userName}
                                    </div>

                                    <div>
                                        <ul class="dropdown-menu text-end " >
                                            <Link to="/myaccount" class="text-decoration-none">
                                                <li class="dropdown-item"
                                                    onClick={e => setActive(e.target.innerText)}
                                                >My Profile</li></Link>
                                            <Link to="/myaccount/placeorders/" class="text-decoration-none">
                                                <li class="dropdown-item" onClick={e => setActive(e.target.innerText)}>
                                                    Orders</li></Link>
                                            <li class="dropdown-item"
                                                onClick={(e) => logout(e)}
                                            >Log out</li>
                                        </ul>
                                    </div>
                                </div>)}
                            {/* <!-- Cart --> */}
                            <li class="nav-item ">
                                <Link to="/cart" class="nav-link" >
                                    {totalCarts > 0 && <span class="count">{totalCarts}</span>}
                                    <span class="material-symbols-outlined">shopping_cart</span>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav >
            {/* footer */}
        </>
    )
}
export default Navbar;